{
    "MaxfilterlistlimitLabel": "Maximum Filter List Limit:",
    "MaxreportrowdisplimitLabel": "Maximum Report Row Display Limit:",
    "MaxfilterlistlimitPlaceholder": "150",
    "MaxreportrowdisplimitPlaceholder": "150",
    "NAME": "ContentRestriction",
    "ContentRestriction_SectionHeader": "Content Restriction",
    "ContentRestriction_SectionPara": "For environments with a large number of devices and/or ACD agents, you can increase the maximum number of items displayed, although this can potentially decrease browser performance."
}